import { createFeatureSelector, createSelector } from '@ngrx/store';
import type { CoreState } from '../core.state';
import { PropertyType } from '../../models/property-type.model';

const featureSelector = createFeatureSelector('core');

export const selectEntityTypesState = createSelector(featureSelector, (state: CoreState) => state.entityTypes);

export const selectEntityTypes = createSelector(selectEntityTypesState, state => state.entityTypes);

export const selectEntityType = (entityTypeKey: string) => {
  return createSelector(selectEntityTypesState, state => state.entityTypes[entityTypeKey]);
};

export const selectPropertyTypes = createSelector(selectEntityTypesState, state => {
  const result: Record<string, PropertyType> = {};

  const entityTypes = state.entityTypes;

  Object.keys(entityTypes).forEach(key => {
    const groupTypes = entityTypes[key].Groups;

    groupTypes.forEach(groupType => {
      groupType.Properties.forEach(propertyType => {
        result[propertyType.Key] = propertyType;
      });
    });
  });

  return result;
});
